import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=06a51c24&scoped=true"
import script from "./Arrows.vue?vue&type=script&lang=js"
export * from "./Arrows.vue?vue&type=script&lang=js"
import style0 from "./Arrows.vue?vue&type=style&index=0&id=06a51c24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a51c24",
  null
  
)

export default component.exports